/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 셀병합 툴을 정의한다.
 *
 * @file /src/rootin/blocks/table/tools/Merge.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 9. 7.
 */
import { Tool } from '@rootin/base/Tool';
import { Block } from '@rootin/base/Block';
import { Element } from '@rootin/base/Element';
import { Language, LanguageText } from '@utils/Language';

export class Merge extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'merge';

    /**
     * 툴그룹
     */
    static group: string = 'table-merge';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-centerline-dashed-horizontal-icon lucide-square-centerline-dashed-horizontal"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 7h18"/><path d="M3 17h18"/><path d="M12 3v4"/><path d="M12 17v4"/><path d="M5 12h6"/><path d="M13 12h6"/><path d="M8 9l-3 3 3 3"/><path d="M16 9l3 3-3 3"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.table.tools.merge');

    /**
     * 툴 클릭시 실행할 핸들러를 정의한다.
     */
    async handler(): Promise<void> {}

    /**
     * 툴의 표시여부 조건을 설정한다.
     * @todo 커서가 편집 가능한 유닛 안이거나 다중 유닛이 선택돼 있을 때만 노출할지 고민한다.
     *
     * @param block - 커서가 위치한 블록
     * @param element - 커서가 위치한 편집유닛
     * @returns 표시여부
     */
    visible(block: Block | null, element: Element | null): boolean {
        return block.getParents('table') !== null;
    }

    /**
     * 툴이 활성여부 조건을 설정한다.
     *
     * @returns 활성여부
     */
    active(): boolean {
        return false;
    }
}
